import { isAuthPath } from "../../Utilities/Auth/loginRedirect";
import { URLS } from "../../Utilities/Maps";

type RiotLinkState = { active?: boolean; hasReplayAccess?: boolean } | null;

export const PROMPT_COOLDOWN_MS = 24 * 3600_000;

const SUPPRESSED_SEGMENTS = [
  URLS.STUDIO,
  URLS.REMIX,
  URLS.MONTAGE,
  URLS.OVERWOLF,
  "/embed",
];

const isSuppressedPath = (pathname: string) =>
  isAuthPath(pathname) ||
  SUPPRESSED_SEGMENTS.some((segment) => pathname.includes(segment));

export const needsRiotRelink = (riot?: RiotLinkState) =>
  !!riot?.active && riot?.hasReplayAccess === false;

export const shouldShowRiotRelinkPrompt = ({
  loggedIn,
  riot,
  pathname,
  modalOpen,
  lastShownAt,
  now,
}: {
  loggedIn: boolean;
  riot?: RiotLinkState;
  pathname: string;
  modalOpen: boolean;
  lastShownAt: number | null;
  now: number;
}) =>
  loggedIn &&
  needsRiotRelink(riot) &&
  !modalOpen &&
  !isSuppressedPath(pathname) &&
  (lastShownAt === null || now - lastShownAt >= PROMPT_COOLDOWN_MS);
